var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as Types from './types';
var notificationGlobalState = {
    data: null,
    error: null,
    loading: false
};
var notificationGlobalReducer = function (state, action) {
    if (state === void 0) { state = notificationGlobalState; }
    switch (action.type) {
        case Types.GET_GLOBAL_NOTIFICATION_INIT:
            return {
                data: null,
                error: null,
                loading: true
            };
        case Types.GET_GLOBAL_NOTIFICATION_SUCCESS:
            return __assign(__assign({}, state), { data: action.data });
        case Types.GET_GLOBAL_NOTIFICATION_ERROR:
            return __assign(__assign({}, state), { error: action.error });
        case Types.GET_GLOBAL_NOTIFICATION_DONE:
            return __assign(__assign({}, state), { loading: false });
        default:
            return state;
    }
};
var NotificationGlobalReducer = {
    notificationGlobalData: notificationGlobalReducer
};
export var notificationGlobalData = function (state) { return (state.notificationGlobalData.data ? state.notificationGlobalData.data : null); };
export var notificationGlobalError = function (state) { return state.notificationGlobalData.error; };
export var isLoadnotificationGlobal = function (state) { return state.notificationGlobalData.loading; };
export default NotificationGlobalReducer;
